import { z } from "zod";

export const productFamilySchema = z.enum(["S5", "S5_S50", "S50"]);

export type ProductFamily = z.infer<typeof productFamilySchema>;
